import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import Check from '../../assets/img/check_circle.svg';
import ErrorIcon from '../../assets/img/error.svg';

const inputTypeStyles = {
  positive: css`
    border: 1px solid ${select('feedbackGreen')};
  `,
  negative: css`
    border: 1px solid ${select('feedbackRed')};
  `
};

const InputContainter = styled.div`
  width: 100%;
  height: 48px;
  border: 1px solid ${select('midDarkGray')};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  ${({ type }) => inputTypeStyles[type]}
`;

const FeddbackIcon = styled.div`
  background-image: url(${({ type }) => (type === 'positive' ? Check : ErrorIcon)});
  background-repeat: no-repeat;
  background-position: right;
  width: 32px;
  height: 48px;
`;

const FeedbackContainer = styled.div`
  display: flex;
`;

const DataContainer = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-weight: 400;
  background-color: ${select('lightGray')};
  color: ${select('darkGray')};
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-top: 3%;
  padding-bottom: 2%;
  padding-left: 3%;
  padding-right: 3%;
  width: 100%;
  cursor: 'not-allowed';
  border-radius: 8px;
`;

const DataSpan = styled.span`
  :not(:last-child):after {
    content: ' / ';
  }
`;

const TitleContainer = styled.div`
  color: ${select('black')};
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 24px;
`;

const SubtitleContainer = styled.div`
  color: ${select('black')};
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 8px;
  margin-bottom: 4px;
`;

const PContainer = styled.p`
  color: ${select('lightBlack')};
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 86%;
  white-space: break-spaces;
  margin-top: 8px;
  ${({ hasError }) =>
    hasError &&
    css`
      color: ${select('feedbackRed')};
    `}
`;

const LinkUpdate = styled.a`
  color: ${select('blueLinks')};
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: break-spaces;
  text-decoration: none;
  cursor: pointer;
`;
const PhoneContainer = styled.div``;

const WhatsAppHelp = styled.div`
  margin-top: 8px;
  color: ${select('black')};
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: break-spaces;
  ${({ hasError }) =>
    hasError &&
    css`
      color: ${select('feedbackRed')};
    `}
`;
const WhatsAppHelpStrong = styled.strong``;

export {
  InputContainter,
  DataContainer,
  TitleContainer,
  SubtitleContainer,
  DataSpan,
  PContainer,
  LinkUpdate,
  WhatsAppHelp,
  WhatsAppHelpStrong,
  PhoneContainer,
  FeddbackIcon,
  FeedbackContainer
};
